import { useContext } from 'react';
import { CardContext } from '../../utils/cardContext';
import { Description as DescriptionComponent } from '../../components/Building/parts/Description';

export const Description = () => {
  const { description } = useContext(CardContext);

  return <DescriptionComponent text={description} />;
};
